import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useMeQuery } from '../../graphql/types';
import { color } from '../../styles/mixins';
import { typography } from '../../styles/typography';

const Center = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  ${typography.fonts.mercury(32)}
  color: ${color('gray80')};
`;

export function PageLoading({ children }: { children: any }) {
  const [loaded, setLoaded] = useState(false);
  const { isLoading, getAccessTokenSilently } = useAuth0();
  (window as any).getAccessTokenSilently = getAccessTokenSilently;
  const { loading: isLoadingMe } = useMeQuery({
    skip: !loaded,
    errorPolicy: 'ignore',
  });

  useEffect(() => {
    if (!isLoading && !isLoadingMe) {
      setTimeout(() => setLoaded(true), 1);
    }
  }, [isLoading, isLoadingMe]);

  if (!loaded) {
    return <Center>Loading...</Center>;
  }
  return <>{children}</>;
}
